<template>
	<div id="form" class="column col-lg-6 col-md-6 col-sm-12">
		<div class="panel">
			<div class="panel-header">
				<div class="panel-title"><b>Générateur de signature mail</b></div>
				<div class="panel-body">
					<form @submit.prevent="submitFields">
						<div class="form-group">
							<label class="form-label" for="input-username"
								>Nom et prénom</label
							>
							<input
								class="form-input"
								type="text"
								id="input-username"
								v-model="username"
								placeholder="Nom et prénom"
							/>
						</div>
						<div class="form-group">
							<label class="form-label" for="input-usertitle"
								>Titre ou fonction</label
							>
							<textarea
								class="form-input"
								id="input-usertitle"
								v-model="usertitle"
								placeholder="Titre ou fonction"
							></textarea>
						</div>
						<div class="form-group">
							<label class="form-label" for="input-userphone"
								>Téléphone</label
							>
							<input
								class="form-input"
								type="text"
								id="input-userphone"
								v-model="userphone"
								placeholder="Téléphone"
							/>
						</div>
						<div class="form-group">
							<label class="form-label" for="input-usermail"
								>Adresse e-mail</label
							>
							<input
								class="form-input"
								type="text"
								id="input-usermail"
								v-model="usermail"
								placeholder="Adresse e-mail"
							/>
						</div>
						<div class="form-group" style="display: none">
							<label class="form-label" for="input-useraddress"
								>Adresse</label
							>
							<textarea
								class="form-input"
								id="input-useraddress"
								v-model="useraddress"
								placeholder="Adresse"
							></textarea>
						</div>

						<div class="form-group" style="display: none">
							<label class="form-label" for="input-usermail"
								>Site web</label
							>
							<input
								class="form-input"
								type="text"
								id="input-usermail"
								v-model="userweb"
								placeholder="Adresse e-mail"
							/>
						</div>
						<div class="form-group">
							<button type="submit" class="btn btn-primary">
								Mettre à jour
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Form",
	data: function () {
		return {
			username: "",
			usertitle: "",
			usertitlehtml: "",
			userphone: "",
			usermail: "",
		};
	},
	watch: {
		usertitle: function (newValue) {
			this.usertitlehtml = newValue.replace(/\r?\n/g, "<br />");
		},
	},
	methods: {
		submitFields: function () {
			this.$emit("submitFields", [
				this.username,
				this.usertitlehtml,
				this.userphone,
				this.usermail,
			]);
		},
	},
};
</script>

<style></style>
